import { createContext, useContext } from "react";

/**
 * Whether the open task's chat composer takes focus when it appears: yes when
 * the task was opened (from the list, the board or a link), no when it was
 * reached by paging or a related-task link, so keyboard paging keeps working.
 */
export const TaskComposerAutoFocusContext = createContext(true);

export const useShouldAutoFocusTaskComposer = () =>
    useContext(TaskComposerAutoFocusContext);
